import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase 설정 (환경 변수 또는 taibong-hp 프로젝트 기본값 사용)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCQlWBQfCvkG0_U7cZmQUCk3z5wjrazOZg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "taibong-hp.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "taibong-hp",
  // NOTE: Must match Firebase Web SDK config for this project.
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "taibong-hp.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "401425284146",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:401425284146:web:cc2509802c581d83c8d02b",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-WPXD46BZEX"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Firestore 및 Storage 인스턴스 생성
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
